import { render } from "./MWAddNews.vue?vue&type=template&id=b6f8fa94"
import script from "./MWAddNews.vue?vue&type=script&lang=js"
export * from "./MWAddNews.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__